import React from "react";
import styles from "./status-tag.module.scss";

export default function StatusTag({
  status,
  text,
  className,
}: {
  status: string;
  text: string;
  className?: string;
}) {
  return (
    <button className={`${styles.statusTag} ${styles[status]} ${className || ""}`}>
      <span>{text}</span>
    </button>
  );
}
